module.exports = __webpack_public_path__ + "static/media/loader.cbd5d85e.gif";